'use strict'

module.exports = {
  copySync: require('./copy-sync')
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-extra/lib/copy-sync/index.js
// module id = 343
// module chunks = 0